import { motion } from 'framer-motion';

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 32, className = '' }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: '-80px' }}
    transition={{ duration: 0.8, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MaskedTitle = ({ lines, as: Tag = 'h1', className = '', lineClassName = '', baseDelay = 0.15 }) => (
  <Tag className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
        <motion.span
          className={`block ${lineClassName}`}
          initial={{ y: '115%' }}
          animate={{ y: 0 }}
          transition={{ duration: 1, delay: baseDelay + i * 0.14, ease: EASE }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </Tag>
);

export const Marquee = ({ text }) => (
  <div className="overflow-hidden border-y border-line/10 py-6 md:py-8 select-none" aria-hidden="true">
    <div className="marquee-track">
      {[0, 1].map((n) => (
        <span
          key={n}
          className="font-display text-4xl md:text-6xl font-medium uppercase tracking-tight whitespace-nowrap pr-4 text-outline"
        >
          {text.repeat(3)}
        </span>
      ))}
    </div>
  </div>
);

export const Overline = ({ children, className = '' }) => (
  <p className={`text-xs font-bold uppercase tracking-[0.25em] text-accent ${className}`}>{children}</p>
);
